import React, {useState} from 'react';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;
const MAX_FILE_SIZE_MB = 100;

export default function FilePicker({home_team_id, target_type, target_id, refresh_target, picker_prefix}) 
{
    const { app_user } = useCTAL();

	const [selectedFile, setSelectedFile] = useState();
	const [isFilePicked, setIsFilePicked] = useState(false);
    const [upload_button_type, setUploadButtonType] = useState("btn btn-secondary"); 
    const [upload_button_display, setUploadButtonDisplay] = useState(<>Upload</>); 
    const [alert_display, setAlertDisplay] = useState(<></>); 

    const refresh = () => { 
        reset_file_picker();
        reset_alert();    
    }

	const changeHandler = (event) => {
		setSelectedFile(event.target.files[0]);
        var s_file = event.target.files[0];
        if (s_file)
            console.log(`FilePicker - selectedFile: ${s_file.name}`);
		setIsFilePicked(true);
        setUploadButtonType("btn btn-primary");
	};

    const reset_file_picker = () => { 
        setSelectedFile();
        setIsFilePicked(false);

        var filePicker = document.getElementById(picker_prefix+"-file-picker");
        if (filePicker) filePicker.value = "";

        setUploadButtonType("btn btn-secondary");
        reset_btn_display();
    }

    const reset_btn_display = () => { setUploadButtonDisplay(<>Upload</>); }

    const set_btn_display_loading = () => { 
        setUploadButtonDisplay(
            <>
                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                <span role="status"> Uploading...</span>
            </>
        );
    }
    
    const reset_alert = () => { setAlertDisplay(<></>); }
    const show_alert = (message) => { setAlertDisplay( <div class="alert alert-warning mt-1" role="alert"> {message} </div> ) }
  
    const upload_via_url = async (res) => {
        if (res.result == "success")
        {
            console.log(`FilePicker - PUT File, ${selectedFile.name}, type: ${selectedFile.type}, size: ${selectedFile.size}, url: ${res.url}`);
            fetch(res.url, { method: "PUT", body: selectedFile, headers: {'Content-Type': selectedFile.type} })
                .then(() => refresh())
                .then(() => refresh_target());
                //.catch(setError);
        }
        else
        {
            console.log(`FilePicker - ${res.message}`);
            reset_btn_display();
            show_alert(res.message);
        }
    }

    const send_url_request = (form_data) => { 

        var object = {};
        form_data.forEach((value, key) => {
            // Reflect.has in favor of: object.hasOwnProperty(key)
            if(!Reflect.has(object, key)){
                object[key] = value;
                return;
            }
            if(!Array.isArray(object[key])){
                object[key] = [object[key]];    
            }
            object[key].push(value);
        });
    
        console.log(`FilePicker - Send URL Request, type: ${object.type}, file: ${object.file_name}`);
        setIsFilePicked(false);
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-file`, { method: "POST", body: form_data })
            .then(response => response.json())
            .then(upload_via_url);
            //.catch(setError);
    }

    const upload_file = () => {    
        if (!isFilePicked) return;
        if (selectedFile.size <= 0) return;

        var file_size_MB = selectedFile.size / 1000000;
        if (file_size_MB > MAX_FILE_SIZE_MB) {
            var file_size_display_MB = Math.floor(selectedFile.size / 100000) / 10;
            show_alert(`Unable to upload file. File size: ${file_size_display_MB} MB exceeds maximum ${MAX_FILE_SIZE_MB} MB`);
            return;
        }

        const formData = new FormData();
        formData.append('type',           "create_storage_file");
        formData.append('home_team_id',   home_team_id);
        formData.append('target_id',      target_id);
        formData.append('target_type',    target_type);
        formData.append('user_full_name', app_user.UserFullName);
        formData.append('file_name',      selectedFile.name);
        formData.append('file_size_bytes',selectedFile.size);

        if (DEBUG) console.log(`FilePicker** - Upload File, home_team_id: ${home_team_id}, target_id: ${target_id}`);
        
        reset_file_picker();
        set_btn_display_loading();
        reset_alert();

        send_url_request(formData);
    }

    var local_picker_prefix = picker_prefix;
    if (picker_prefix == undefined)
        local_picker_prefix = "Local";

    return (
        <>
            <div class="input-group input-group-sm mt-0">
                <input id={local_picker_prefix+"-file-picker"} type="file" class="form-control" onChange={changeHandler} />
                <button id="file-picker-btn" class={upload_button_type} type="button" onClick={upload_file}>
                    {upload_button_display}
                </button>
            </div>                               
            
            {alert_display}
        </>
    );
}